import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

// Landing Page Pages
import LandingPage from './pages/landingpage/LandingPage';
import BlogListPage from './pages/landingpage/BlogListPage';
import BlogDetailPage from './pages/landingpage/BlogDetailPage';

// Admin Pages  
import AdminDashboard from './pages/admin/AdminDashboard';
import TopProgressBar from './components/landingpage/TopProgressBar';

/**
 * Inner component with all routes.
 */
const AppRoutes: React.FC = () => {
  return (
    <>
      <TopProgressBar />
      <Routes>
      {/* Landing Page Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/blogs" element={<BlogListPage />} />
      <Route path="/blogs/:slug" element={<BlogDetailPage />} />

      {/* Admin Routes (Login + Protected Dashboard) */}
      <Route path="/admin/*" element={<AdminDashboard />} />

      {/* 404 - Redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
};

/**
 * Main App Component
 * Routes structure:
 * - Public: /  (Landing page)
 * - Admin: /admin/* (Login at /admin/login, Dashboard after auth)
 */
function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
